import { utils } from '@febos-io/common';

import * as types from './types';

export const initialState = {
  isLoading: false,
  userSession: undefined,
  user: undefined,
  company: undefined,
  companies: [],
  relations: [],
};

export const slice = utils.createSlice('auth', initialState, {
  [types.SET_USER_SESSION](state, { payload, }) {
    return {
      ...state,
      userSession: payload,
    };
  },
  [types.SET_USER](state, { payload, }) {
    return {
      ...state,
      user: payload,
    };
  },
  [types.REMOVE_USER]() {
    return initialState;
  },
  [types.CLEAR_USER_SESSION](state) {
    return {
      ...state,
      company: undefined,
      companies: [],
      relations: [],
    };
  },
  [types.SET_LOADING](state, { payload, }) {
    return {
      ...state,
      isLoading: payload,
    };
  },
  [types.SET_USER_COMPANY](state, { payload: { company, ...user }, }) {
    return {
      ...state,
      user,
      company: company,
    };
  },
  [types.SET_USER_METADATA](state, { payload, }) {
    return {
      ...state,
      companies: payload.companies,
    };
  },
  [types.SET_USER_CLINIC](state, { payload: clinic, }) {
    return {
      ...state,
      clinic: clinic,
    };
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
export default slice.reducer;
